import { ComponentPropsWithoutRef, ElementRef, forwardRef, ReactNode } from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';

import { IconProps } from '../Icons';

import { cn } from 'styles';
import { ComponentOrNode } from '../helpers';

type PrimitiveProps = ComponentPropsWithoutRef<typeof LabelPrimitive.Root>;

type LabelProps = Pick<PrimitiveProps, 'className' | 'htmlFor' | 'children'> & {
  icon?: ReactNode | ((p: IconProps) => JSX.Element);
};

export const Label = forwardRef<ElementRef<typeof LabelPrimitive.Root>, LabelProps>(
  ({ className, icon: LabelIcon, children, ...props }, ref) => (
    <LabelPrimitive.Root
      ref={ref}
      {...props}
      className={cn(
        'flex items-center gap-2 text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
        className,
      )}
    >
      <ComponentOrNode target={LabelIcon} size={14} />

      {children}
    </LabelPrimitive.Root>
  ),
);

Label.displayName = LabelPrimitive.Root.displayName;
